import type {MessagePartComponentProps} from '../MessagePartComponentContext';
import {SourcesDropdown} from '../../StripeAssistant/LiveAnswersV2/SourcesDropdown';
import {useConversationTypewriting} from '../ConversationActivityIndicatorProvider';

export function SourcesPartComponent({
  message,
  part,
}: MessagePartComponentProps) {
  const {sources} = part.content as any;
  const {isMessageTypewriting} = useConversationTypewriting();
  const messageData = message.data as
    | {conversationsApi?: {messageId?: string}}
    | undefined;
  const sourceMessageId = messageData?.conversationsApi?.messageId;

  if (
    !sources ||
    sources.length === 0 ||
    (sourceMessageId && isMessageTypewriting(sourceMessageId))
  ) {
    return null;
  }

  return <SourcesDropdown sources={sources} />;
}
